<script setup>
const props = defineProps(['to', 'hash', 'href', 'disabled', 'processing', 'icon', 'target', 'content'])
</script>

<template>
	<a class="btn animation" v-if="href" :href="href" :target="target ?? '_blank'">
		<div class="button-text" v-if="!content">
			<slot></slot>
		</div>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</a>
	<router-link class="btn animation" v-else-if="to" :to="to">
		<div class="button-text" v-if="!content">
			<slot></slot>
		</div>
		<template v-else>
			<slot></slot>
		</template>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</router-link>
	<button class="btn animation" v-else :disabled="disabled">
		<i class="fas fa-circle-notch fa-spin animate-spin" v-if="processing"></i>
		<div class="button-text">
			<slot></slot>
		</div>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
	</button>
</template>

<style scoped>
.btn {
	@apply relative flex flex-row text-body-sm;
}

.btn-outline {
	@apply flex h-12 items-center justify-center gap-3 overflow-hidden rounded-full p-5 outline-dashed outline-2 outline-sf-purple-base;
}

.btn-outline.big {
	@apply h-24 w-full px-10 py-5 font-heading text-display-sm;
}

.btn-outline.small {
	@apply w-fit rounded-small p-5;
}

.btn-outline::before {
	content: '';
	@apply absolute inset-1 rounded-[96px] bg-sf-purple-base;
	@apply animation origin-center scale-0 transform;
}

.btn-outline .icon {
	@apply flex h-5 w-5 items-center justify-center rounded-full;
}

.btn-outline:hover::before {
	@apply scale-100;
}

.btn-outline .button-text {
	@apply animation z-header justify-start font-body font-medium uppercase leading-none tracking-wide text-purple-300;
}

.btn-outline:hover .button-text {
	@apply text-bg-dark;
}

/* Disabled state - no animations or hover effects */
.btn-outline:disabled::before {
	@apply scale-0 !important;
}

.btn-outline:disabled:hover::before {
	@apply scale-0 !important;
}

.btn-outline:disabled .button-text {
	@apply opacity-50;
}

.btn-outline:disabled:hover .button-text {
	@apply text-purple-300 opacity-50;
}

.btn-outline:disabled {
	@apply cursor-not-allowed;
}

.btn-outline:disabled:hover {
	@apply cursor-not-allowed;
}

/* Chip variant for category pills */
.btn-chip {
	@apply flex h-8 items-center justify-center gap-3 overflow-hidden rounded-small px-5 outline-dashed outline-2 outline-sf-purple-base;
}

.btn-chip .button-text {
	@apply font-body text-body-sm font-medium uppercase leading-4 tracking-[0.84px] text-text-base;
}

.btn-chip:hover {
	@apply bg-sf-purple-base outline;
}

.btn-chip:hover .button-text {
	@apply text-bg-dark;
}

.btn-chip.active {
	@apply bg-sf-purple-base outline;
}

.btn-chip.active .button-text {
	@apply text-bg-dark;
}
</style>
